/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-23 16:11:05
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 14:44:45
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/InputSelectAndDelete/index.tsx
 */

import React, { ReactNode } from 'react';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Input from '@/src/components/Antd/Input/Input';

//import css from './css.less';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

interface IProps {
  inputTitle: ReactNode | string;
  selectTitle: ReactNode | string;
  onSelectChange: (e, item) => void;
  onSetInputValue: (value) => void;
  selectValue: string | number;
  inputValue: string;
  rightPart?: ReactNode | string;
  inputErr?: boolean;
  selectErr?: boolean;
  onSetInputErr?: (boolean) => void;
  onSetSelectErr?: (boolean) => void;
  inputHelp?: string;
  selectHelp?: string;
  maxLength?: number;
  linkSet: any;
  hideLink?: boolean;
}

const InputSelectAndDelete = (props: IProps) => {
  const {
    inputTitle = '',
    selectValue,
    inputValue = '',
    onSelectChange,
    onSetInputValue,
    inputErr,
    selectErr,
    rightPart,
    onSetInputErr,
    onSetSelectErr,
    inputHelp,
    selectHelp,
    maxLength = 50,
    linkSet,
    hideLink,
  } = props;

  const handleInputOnChange = (e) => {
    onSetInputValue(e);
    if (inputErr && onSetInputErr) onSetInputErr(false);
  };

  const handleSelectOnChange = (value, indexItem) => {
    onSelectChange(value, indexItem);
    if (selectErr && onSetSelectErr) onSetSelectErr(false);
  };
  return (
    // <div className={css.container}>
    <Section hasBottomBorder>
      <ItemWrapper title={inputTitle} rightPart={rightPart}>
        <Input
          error={inputErr}
          autoFocus
          size='large'
          help={inputHelp}
          value={inputValue}
          onChange={handleInputOnChange}
          maxLength={maxLength}
        />
      </ItemWrapper>
      {!hideLink && (
        <LinkLibrary
          error={selectHelp}
          data={selectValue}
          onChange={(value) => handleSelectOnChange(value, {})}
          linkSet={linkSet}
        />
      )}
    </Section>
  );
};

export default InputSelectAndDelete;
